module.exports = __webpack_public_path__ + "img/DE00316.6a0dbedd.png";